const features = [
  {
    id: 1,
    icon: 'ri-movie-2-line',
    title: '海量影视资源',
    desc: '覆盖电影在线观看、电视剧免费、综艺节目等全品类影视视频，每日更新最新影视内容，满足各类观影需求。',
    color: 'text-primary-600 bg-primary-100',
  },
  {
    id: 2,
    icon: 'ri-4k-line',
    title: '高清不缓冲',
    desc: '先进的视频分发技术确保高清画质与流畅播放，告别卡顿等待，享受无缝观影体验，高清免费看不停。',
    color: 'text-accent-600 bg-accent-100',
  },
  {
    id: 3,
    icon: 'ri-smartphone-line',
    title: '多端适配观看',
    desc: 'PC、平板、手机多设备完美适配，随时随地打开天美麻花星空影视免费观看继续你的观影之旅。',
    color: 'text-secondary-600 bg-secondary-100',
  },
  {
    id: 4,
    icon: 'ri-shield-check-line',
    title: '安全无广告',
    desc: '纯净观影环境，无弹窗广告干扰。91电影视频和麻豆影视在线观看均经过安全检测，放心畅享。',
    color: 'text-primary-600 bg-primary-100',
  },
];

export default function FeaturesSection() {
  return (
    <section id="features" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-[1280px] mx-auto">
          <div className="text-center mb-10 md:mb-14">
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">
              平台特色
            </h2>
            <p className="text-sm text-foreground-500 max-w-lg mx-auto">
              为什么选择天美麻花星空影视免费观看
            </p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
            {features.map((feature) => (
              <div key={feature.id} className="bg-background-50 rounded-xl p-6 border border-background-200/70 text-center hover:border-primary-200 transition-all duration-300 cursor-pointer group">
                <div className={`w-14 h-14 rounded-xl ${feature.color} flex items-center justify-center mx-auto mb-4 group-hover:scale-110 transition-transform duration-300`}>
                  <i className={`${feature.icon} text-xl`}></i>
                </div>
                <h3 className="text-sm font-heading font-semibold text-foreground-900 mb-2">{feature.title}</h3>
                <p className="text-xs text-foreground-500 leading-relaxed">{feature.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}